import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';

export const permissionGuard: CanActivateFn = async (route) => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  await permissions.ensureLoaded();

  const required = route.data['permission'] as string | undefined;
  const anyOf = route.data['anyPermission'] as string[] | undefined;
  const allowed = required ? permissions.has(required) : anyOf ? permissions.hasAny(anyOf) : true;
  return allowed ? true : router.createUrlTree(['/forbidden']);
};

/** Sends `/` to the first page this admin is allowed to open. */
export const homeRedirectGuard: CanActivateFn = async () => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  await permissions.ensureLoaded();
  return router.createUrlTree([permissions.firstAllowedPath() ?? '/forbidden']);
};

export const configEntryGuard: CanActivateFn = async () => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  await permissions.ensureLoaded();
  if (permissions.has('config.points.read')) return router.createUrlTree(['/config/points']);
  if (permissions.has('config.streak.read')) return router.createUrlTree(['/config/streak']);
  return router.createUrlTree(['/forbidden']);
};

export const notificationsEntryGuard: CanActivateFn = async () => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  await permissions.ensureLoaded();
  if (permissions.has('notifications.read')) return router.createUrlTree(['/notifications/history']);
  if (permissions.has('notifications.send')) return router.createUrlTree(['/notifications/send']);
  return router.createUrlTree(['/forbidden']);
};
